const initialState = {
	loading: false
};

export default function loadingReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_START':
			return {
				loading: true
			};
		case 'LOADING_END':
			return {
				loading: false
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/loadingReducer.js